import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-textbox',
   templateUrl: './textbox.component.html',
   styleUrls: ['./textbox.component.scss']
})
export class TextboxComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() placeholder: any;
   @Input() labelName: any;
   @Input() isFormName: any;
   @Input() hideHeader: boolean = false;
   defaultValidate: string;
   lang: any;
   regexMessage: string;
   value: any;

   constructor(private translate: TranslateService, private eformService: EformService, private cdr: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      this.value = this.eformService.eForm?.value.value && this.eformService.eForm?.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
      this.translate.get('eform.errors.invalid-input').subscribe(s => {
         this.defaultValidate = s;
      });
      if (this.field.regexMessage !== undefined) {
         if (this.field.regexMessage.en === '' && this.field.regexMessage.th === '') {
            this.regexMessage = this.defaultValidate;
         } else {
            if (this.lang === 'en') {
               if (this.field.regexMessage.en === '') {
                  this.regexMessage = this.field.regexMessage.th;
               } else {
                  this.regexMessage = this.field.regexMessage.en;
               }
            } else {
               if (this.field.regexMessage.th === '') {
                  this.regexMessage = this.field.regexMessage.en;
               } else {
                  this.regexMessage = this.field.regexMessage.th;
               }
            }
         }
      }
      this.cdr.detectChanges();
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }
}
